import {APIRequestConfig} from "../../API"
import setIfNotSet from "../../../setIfNotSet"
import getClientDetails from "../../apollo/helpers/getClientDetails"

export default async function appendApolloClientValues(config: APIRequestConfig) {
  return getClientDetails().then(({name, version}) => {
    setIfNotSet(config, "headers['apollographql-client-name']", name)
    setIfNotSet(config, "headers['apollographql-client-version']", version)
  })
}
